import { Delay, Execute, SequenceChain, Sound, consumer, inject } from "@spawn/core";
import { ParallelModules, ScatterModule, showSymbolsOnSpotlight } from "@spawn/slot-machine";
import { SymbolService } from "../services/symbolService";

@consumer
export class NrgScatterModule extends ScatterModule {
	@inject protected readonly symbolService!: SymbolService;

	protected readonly trimAmount: number;
	soundInstance?: Sound;

	/** @param trimAmount First N scatters use scatter animation; rest use +1. Default 3 (base game). Use 0 in freegames. */
	constructor(trimAmount: number = 3) {
		super(ScatterModule.name);
		this.trimAmount = trimAmount;
	}

	// override reason: mostly same chain, but with some changes to highlight the extra scatters
	// and to make the sound cancelable
	protected override createScatterChain(): SequenceChain {
		return new SequenceChain(
			new Execute(() => {
				this.partyService.stopParallelModule(ParallelModules.LineStepper);
			}),
			new Execute(() => {
				this.ambientSoundController.fadeOutSound();
				if (!this.soundInstance) {
					this.soundInstance = new Sound(this.scatterAnimationSound(), true);
				}
				void this.soundInstance.play();
				this.replaceScatterSymbols();
				this.eventDispatcher.dispatch(
					showSymbolsOnSpotlight({
						symbolCoordinates: this.scatterSymbolsCoords,
						symbolMetaDataKeys: [this.scatterMetaDataKey()],
						loopAnimations: false,
						disableDimming: false,
					})
				);
				// show the +1 animation
				this.eventDispatcher.dispatch(
					showSymbolsOnSpotlight({
						symbolCoordinates: this.extraScatterSymbolsCoords,
						symbolMetaDataKeys: ["BonusAnimationExtra"],
						loopAnimations: false,
						disableDimming: false,
					})
				);
			}),
			new Delay(this.animationDuration())
		);
	}

	public override stop(): void {
		if (this.soundInstance) {
			void this.soundInstance.stop();
		}
		super.stop();
	}

	// override reason: get only the first three scatter symbols (instead of the usual 'all') which will show the normal animation
	protected override get scatterSymbolsCoords(): { x: number; y: number }[] {
		return this.symbolService.getScatterSymbolsCoords().slice(0, this.trimAmount);
	}

	private get extraScatterSymbolsCoords(): { x: number; y: number }[] {
		return this.symbolService.getScatterSymbolsCoords().slice(this.trimAmount);
	}

	protected override replaceScatterSymbols(): void {
		// no-op because it causes issues if we win scatters during golden bonus
	}
}
